/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
const HOURS_PER_MONTH = 720;

export const calculateComputePlanCostPerHour = (
  cpu: number,
  memoryGb: number,
  cpuPricePerMonth: number,
  memoryPricePerMonth: number,
) => (cpu * cpuPricePerMonth + memoryGb * memoryPricePerMonth) / HOURS_PER_MONTH;

export const calculateStoragePlanCostPerHour = (storageGb: number, storagePricePerMonth: number) =>
  (storageGb * storagePricePerMonth) / HOURS_PER_MONTH;
